/**
 * Generates a callback to be called when info icon is pressed, sends tealium tracking and onInfoIconPress callback
 *
 * @param {object} params - Parameters
 * @param {string} params.analyticsTitle - title to pass to tealium
 * @param {string} params.name - the route name from react navigation
 * @param {function} params.onInfoIconPress - a callback to call on Press
 * @param {function} params.sendEvent - a callback to send the tealium request
 *
 * @returns {function} - Callback - A function to be called when tab is pressed
 */
export function generateOnPress({
  analyticsTitle,
  name,
  onInfoIconPress,
  sendEvent,
  lastPaidRank,
}: any) {
  return () => {
    onInfoIconPress();

    sendEvent({
      buttonName: analyticsTitle,
      screenName: name,
      lastPaidRank: lastPaidRank,
    });
  };
}
